export default "/assets/images/outdoor-aqi-video-thumbnail.jpg?baa2435a6a12be1953263ad58d00f93b";